
















import Vue from 'vue';

import Paragraphs from '@/components/Paragraphs.vue';
import BookFilters from '@/components/BookFilters.vue';

export default Vue.extend({
	name      : 'FilteredContent',
	components: {
		Paragraphs,
		BookFilters,
	},
});
